import React, { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import ProcessSection from '../components/sections/ProcessSection';
import ProjectsSection from '../components/sections/ProjectsSection';
import BeforeAfterSection from '../components/sections/BeforeAfterSection';
import WhyUsSection from '../components/sections/WhyUsSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import StatsSection from '../components/sections/StatsSection';
import ContactSection from '../components/sections/ContactSection';

const HomePage = () => {
  const { currentLang } = useLanguage();

  useEffect(() => {
    document.title = currentLang === 'ar'
      ? 'أرمان كيتشنز — مطابخ فاخرة مصممة خصيصاً'
      : 'Arman Kitchens — Luxury Custom Kitchen Design';
  }, [currentLang]);

  return (
    <main data-testid="home-page">
      <HeroSection />
      <AboutSection />
      <ProcessSection />
      <ProjectsSection />
      <BeforeAfterSection />
      <WhyUsSection />
      <TestimonialsSection />
      <StatsSection />
      <ContactSection />
    </main>
  );
};

export default HomePage;
